import React from 'react';
import styled from 'styled-components';
import { i18n } from '@lt/localization';

import SuperCashback from '@lt/components/components/CashBack/SuperCashBack';
import CustomBooleanFilterGroup from '../components/CustomBooleanFilterGroup';

import type { IFilter } from '../types';

const FILTER_KEY = 'super_cashback';

const CUSTOM_FILTERS = [FILTER_KEY];

const FILTER_LABEL = i18n.t('filters.super_cashback.title');

let FILTER_NAMES: Record<string, string> = {};

export const FilterSuperCashback = (props: IFilter): JSX.Element => {
  FILTER_NAMES = {
    [FILTER_KEY]: i18n.t(
      window.SEARCH_PARAMS?.search_type === 'hotel'
        ? 'filters.super_cashback.options.hotels'
        : 'filters.super_cashback.options.packages',
    ),
  };
  return (
    <CustomBooleanFilterGroup
      {...props}
      Filter={{
        filterLabel: (
          <>
            {FILTER_LABEL}
            <StyledIconWrapper>
              <StyledIcon />
            </StyledIconWrapper>
          </>
        ),
        FILTER_NAMES,
        customFilters: CUSTOM_FILTERS,
      }}
    />
  );
};

export default Object.assign(FilterSuperCashback, {
  filterLabel: FILTER_LABEL,
  filterName: FILTER_KEY,
  customFilters: CUSTOM_FILTERS,
  FILTER_NAMES,
});

const StyledIconWrapper = styled.span`
  position: relative;
`;

const StyledIcon = styled(SuperCashback)`
  position: absolute;
  bottom: -1px;
  left: -2px;
  height: 28px !important;
  width: 28px !important;
`;
